import { SVGProps } from 'react';

export const ArrowUpIcon = (props: SVGProps<SVGSVGElement>) => {
  return (
    <svg data-icon width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M9 15.1875C8.68934 15.1875 8.4375 14.9357 8.4375 14.625L8.4375 4.73299L4.33525 8.83525C4.11558 9.05492 3.75942 9.05492 3.53975 8.83525C3.32008 8.61558 3.32008 8.25942 3.53975 8.03975L8.60225 2.97725C8.82192 2.75758 9.17808 2.75758 9.39775 2.97725L14.4602 8.03975C14.6799 8.25942 14.6799 8.61558 14.4602 8.83525C14.2406 9.05492 13.8844 9.05492 13.6648 8.83525L9.5625 4.733L9.5625 14.625C9.5625 14.9357 9.31066 15.1875 9 15.1875Z"
        fill="currentColor"
      />
    </svg>
  );
};
